module.exports = __webpack_public_path__ + "img/work2020CHIVoiceCoach.9edb6cf7.png";